module.exports = __webpack_public_path__ + "img/Speaker=Vivian Phung.34740bc7.png";